import {UIPopupController} from '../../ui_popup/UIPopupController'
import {removeURLParams} from '../../ui_utils/Utils'

export abstract class UIHeaderController {
    constructor() {
        UIHeaderController.displayAccountDeletionPopup()
    }

    private static displayAccountDeletionPopup() {
        const urlSearchParams = new URLSearchParams(window.location.search)
        if(!urlSearchParams.has('account-deleted')) return

        UIPopupController.createSimplePopup({key: 'strings:popups.accountDeletionConfirmation.title'}, {key: 'strings:popups.accountDeletionConfirmation.body'})
        removeURLParams()
    }
}
